const getCookieDomains = () =>
  window.location.hostname === "www.asos.com"
    ? [".asos.com", ".www.asos.com"]
    : [".asosservices.com", ".test.asosservices.com"];

export default getCookieDomains;
